// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./static/css/mobile.css
// module id = 864
// module chunks = 41